import { cn } from '../lib/cn.js'
import { Badge } from './Badge.js'

/**
 * Cabeçalho de um grupo de adicionais, com a regra min/max visível ANTES de a
 * pessoa errar. "Escolha até 2" dito na hora economiza um erro de validação
 * no fim do formulário.
 */
export function GrupoEscolhas({
  nome, min, max, obrigatorio, escolhidos = 0, children, className,
}: {
  nome: string
  min: number
  max: number
  obrigatorio?: boolean | undefined
  escolhidos?: number | undefined
  children: React.ReactNode
  className?: string | undefined
}) {
  const regra =
    min > 0 && min === max ? `Escolha ${min}`
    : min > 0 ? `Escolha de ${min} a ${max}`
    : max === 1 ? 'Escolha 1 (opcional)'
    : `Escolha até ${max}`
  const completo = escolhidos >= min

  return (
    <fieldset className={cn('du-grupo', className)}>
      <legend className="du-grupo__cabecalho">
        <span className="du-grupo__nome">{nome}</span>
        {obrigatorio ? (
          <Badge tom={completo ? 'sucesso' : 'destaque'}>{completo ? 'ok' : 'obrigatório'}</Badge>
        ) : null}
        <span className="du-grupo__regra">{regra}</span>
      </legend>
      <div className="du-grupo__itens">{children}</div>
    </fieldset>
  )
}
